export enum Status {
  Open = '1',
  Approved = '2',
  Denied = '3'
}

export enum Business {
  Fire = 'F',
  Security = 'S',
  Automation = 'A',
  Electrical = 'E',
  Mechanical = 'M',
}

export enum EstimateType {
  OP44 = '1',
  Type2600 = '2',
  Type5200 = '3'
}

export enum SearchType {
  None = -1,
  EstimateID = 0,
  EstimateName = 1,
  Reviewer = 2,
}

export enum HttpMethod {
  Post = 'Post',
  Get = 'Get',
  Put = 'Put',
  Delete = 'Delete',
  BeforeLoginPost = 'beforeLoginPost'
}

export enum Discipline {
  Automation = 1,
  Electrical = 2,
  Mechanical = 3,
  Energy = 4,
  Fire = 5,
  Sprinkler = 6,
  Security = 7,
  Multi_Disipline = 8
}

export enum EstimateDateCriteria {
  Modified = 1,
  Created = 2
}

export enum EstimateDBSearch {
  Standard = '1',
  Archive = '2',
}

export enum Months {
  NO_Month = 0,
  January = 1,
  February = 2,
  March = 3,
  April = 4,
  May = 5,
  June = 6,
  July = 7,
  August = 8,
  September = 9,
  October = 10,
  November = 11,
  December = 12,
}

export enum ReleaseEditAccessRadioOptions {
  Publish = '0',
  Discard = '1'
}

export enum LaborTypeEnum {
  PM = 'PM',
  ENG = 'ENG',
  Prog = 'Prog',
  Grap = 'Grap',
  SPEC = 'SPEC',
  DDS = 'DDS',
  Ddep = 'Ddep',
  MECH = 'MECH',
  ELEC = 'ELEC'
}

export enum ProjectCategoryVerification {
  ProjectCategory0 = '0',
  ProjectCategory1 = '1',
  ProjectCategory2 = '2'
}

export enum SA_Tabs {
  SA_COSTS_AND_LABORS = 0,
  SA_SUMMARY = 1,
  SA_SITE_QUALIFICATION = 2,
  SA_PROVEN_OUTCOMES = 3,
  SA_SCOPE = 4,
  SA_EQUIPMENTS = 5,
  SA_MARGINS = 6,
  SA_RISKS = 7,
  SA_TOOL = 8,
  SA_SAP_MATERIAL_NUMBER = 9,
  SA_SERVICES = 10,
  SA_POLICY_EXCEPTIONS = 11,
  SA_OTHER = 12
}

export enum SOL_Tabs {
  SOL_HOURS_TASKS = 0,
  SOL_LABOR_AND_COSTS = 1,
  SOL_OVERTIME = 2,
  SOL_SUMMARY = 3,
  SOL_MATERIAL = 4,
  SOL_RISK = 5,
  SOL_SUBS_AND_MISC = 6,
  SOL_POLICY_EXCEPTIONS = 7,
  SOL_MARGINS = 8,
  SOL_CONDITIONS = 9,
  SOL_BID_DOCUMENTATION = 10,
  SOL_CONTRACTUAL_DOCUMENTATION = 11,
  SOL_PM_REQUIREMENTS = 12,
  SOL_OTHER = 13,
  SOL_CHECKLIST_COMPLETE = 14

}

export enum CULTURE_ID {
  EN_US = 1,
  FR_CA = 2,
  EN_CA = 3
}

export enum CostReviewEstimateType
{
    None = 0,
    EstimateLess50K = 1,
    Estimate50_150K = 2,
    EstimateGreater150K = 3
}

export enum InstallationType {
  TennantMacAddition = 'Tennant/MAC/Addition',
  Retrofit = 'Retrofit',
  Migration = 'Migration',
  NewConstruction = 'New Construction',
}

export enum ProductOffering {
  FIRE_ALARM = 'FIRE_ALARM',
  FIRE_SPRINKLER = 'FIRE_SPRINKLER',
  GASEOUS_SYSTEM = 'GASEOUS_SYSTEM',
  ERCES = 'ERCES'
}